<div class="results-card">
	<ng-container *ngIf="title.length > 0">
		<div class="flex justify-content-between align-items-center px-4 py-3">
			<h4 class="mb-0">{{ title }}</h4>
		</div>
	</ng-container>

	<div class="text-center p-5">
		<i class="pi pi-clock text-6xl text-gray-400 mb-3"></i>
		<h3 class="text-gray-600">Coming Soon...</h3>
	</div>
</div>
